import { Box, Tooltip, Typography } from '@mui/material';

export default function LeafLabel({
    label,
    count,
    tooltip,
}: {
    label: string;
    count?: number;
    tooltip?: string;
}) {
    return (
        <Tooltip title={tooltip} placement="right">
            <Box
                position="relative"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography noWrap fontSize={14} height={20}>
                    {label}
                </Typography>
                <Typography left={-8} top={6} fontSize={12} color="primary">
                    {count}
                </Typography>
            </Box>
        </Tooltip>
    );
}
